module.exports = __webpack_public_path__ + "img/usia.74c3fb98.png";